import { useState, useEffect, useRef } from 'react';

const prints = [
  { src: 'https://static.readdy.ai/image/81c0d91d09d1396d9a4289b3cac449c6/58a37cd60743afdff51bbcb863d0f2d5.png', alt: 'Depoimento Lucia Lins' },
  { src: 'https://static.readdy.ai/image/81c0d91d09d1396d9a4289b3cac449c6/ab24f11cfb17debac4247635d07b9b15.png', alt: 'Depoimento Ana' },
  { src: 'https://static.readdy.ai/image/81c0d91d09d1396d9a4289b3cac449c6/ecbb536ffca81aae165781083938de10.png', alt: 'Depoimento cuidador' },
  { src: 'https://static.readdy.ai/image/81c0d91d09d1396d9a4289b3cac449c6/5daa73971cbd0c1d524bd5458dff61ca.png', alt: 'Depoimento Joao Santos' },
];

export default function PrintsCarousel() {
  const [current, setCurrent] = useState(0);
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  const startAuto = () => {
    intervalRef.current = setInterval(() => {
      setCurrent(prev => (prev + 1) % prints.length);
    }, 3500);
  };

  const resetAuto = () => {
    if (intervalRef.current) clearInterval(intervalRef.current);
    startAuto();
  };

  useEffect(() => {
    startAuto();
    return () => {
      if (intervalRef.current) clearInterval(intervalRef.current);
    };
  }, []);

  const goTo = (index: number) => {
    setCurrent(index);
    resetAuto();
  };

  const prev = () => {
    setCurrent(p => (p - 1 + prints.length) % prints.length);
    resetAuto();
  };

  const next = () => {
    setCurrent(p => (p + 1) % prints.length);
    resetAuto();
  };

  return (
    <div className="mt-20">
      <div className="text-center mb-10">
        <span className="inline-block text-xs font-bold tracking-widest text-teal-600 uppercase mb-3">Conversas reais</span>
        <h3 className="text-2xl lg:text-3xl font-bold text-gray-900">
          Mensagens diretas de quem aplicou o protocolo
        </h3>
        <p className="text-gray-500 mt-3 text-base">Prints enviados espontaneamente por familiares cuidadores</p>
      </div>

      <div className="relative flex flex-col items-center">
        {/* Imagem principal */}
        <div className="relative w-full max-w-sm mx-auto">
          <div className="rounded-2xl overflow-hidden border border-gray-200 bg-white w-full">
            <img
              key={current}
              src={prints[current].src}
              alt={prints[current].alt}
              className="w-full h-auto object-contain transition-opacity duration-500"
            />
          </div>

          {/* Botão anterior */}
          <button
            onClick={prev}
            className="absolute left-2 sm:left-[-48px] top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full bg-white/90 sm:bg-white border border-gray-200 text-gray-600 hover:bg-teal-50 hover:border-teal-300 hover:text-teal-600 transition-all cursor-pointer whitespace-nowrap z-10"
            aria-label="Anterior"
          >
            <i className="ri-arrow-left-s-line text-xl"></i>
          </button>

          {/* Botão próximo */}
          <button
            onClick={next}
            className="absolute right-2 sm:right-[-48px] top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full bg-white/90 sm:bg-white border border-gray-200 text-gray-600 hover:bg-teal-50 hover:border-teal-300 hover:text-teal-600 transition-all cursor-pointer whitespace-nowrap z-10"
            aria-label="Próximo"
          >
            <i className="ri-arrow-right-s-line text-xl"></i>
          </button>
        </div>

        {/* Dots */}
        <div className="flex items-center gap-2 mt-6">
          {prints.map((_, i) => (
            <button
              key={i}
              onClick={() => goTo(i)}
              className={`rounded-full transition-all duration-300 cursor-pointer whitespace-nowrap ${
                i === current
                  ? 'w-6 h-2.5 bg-teal-500'
                  : 'w-2.5 h-2.5 bg-gray-300 hover:bg-teal-300'
              }`}
              aria-label={`Ir para print ${i + 1}`}
            />
          ))}
        </div>

        {/* Contador */}
        <p className="text-sm text-gray-400 mt-3">{current + 1} de {prints.length}</p>
      </div>
    </div>
  );
}
